module.exports = __webpack_public_path__ + "assets/img/placeholder/image-rich-content-300x169.jpg";